export const removeUndefinedFields = <T extends Record<string, unknown>>(obj: T): T => {
  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key]);
  return obj;
};
